/* eslint-disable import/prefer-default-export */
import { TimelineVehicleStatesMessages, TranslationTimelineVehicleStatesMessages } from "../interfaces";

export const messages: TranslationTimelineVehicleStatesMessages = {
  [TimelineVehicleStatesMessages.statesTitle]: "Estados",
  [TimelineVehicleStatesMessages.manometer]: "Manómetro",
  [TimelineVehicleStatesMessages.blockedVehicle]: "Vehículo bloqueado",
  [TimelineVehicleStatesMessages.blockingDate]: "Momento del bloqueo",
  [TimelineVehicleStatesMessages.postUnloadIdleTime]: "Inactividad post-descarga",
  [TimelineVehicleStatesMessages.effectiveUnloadTime]: "Descarga efectiva",
  [TimelineVehicleStatesMessages.unloadBreakdownTitle]: "Dentro de Descargando",
  [TimelineVehicleStatesMessages.unloadBreakdownHelp]: "Descarga efectiva: trompo descargando.\n"
    + "Inactividad post-descarga: trompo detenido hasta que el camión sale de la obra."
};
